export const COUPON_TYPES = ['MARKETING_COUPON', 'STAMP_VOUCHER']
export const CLIENT_MONITOR_COUPON_TYPES = [...COUPON_TYPES, 'ONE_TIME_COUPON']
